import { useGetTypesenseDocumentById } from '@/api/typesense/document';
import type { FacetConfig } from '@/lib/resource-config/types';

interface UseFacetOptionDetailsProps {
  facetConfig: FacetConfig;
  entityId: string | null;
  enabled?: boolean;
}

export const useFacetOptionDetails = ({
  facetConfig,
  entityId,
  enabled = true,
}: UseFacetOptionDetailsProps) => {
  const { valueSource } = facetConfig;
  const isCollection = valueSource.kind === 'collection';

  return useGetTypesenseDocumentById({
    collection: isCollection ? valueSource.collection : null,
    idField: isCollection ? valueSource.idField : null,
    apiKeyName: isCollection
      ? (valueSource.apiKeyName ?? valueSource.collection)
      : '',
    entityId,
    enabled: enabled && isCollection,
  });
};
